"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateInputModeConfig = validateInputModeConfig;
exports.getInputModeWarnings = getInputModeWarnings;
const activityTypes_1 = require("../curriculum/activityTypes");
const INPUT_MODES = [
    'canvas',
    'keyboard',
    'speech',
    'numpad',
    'word_tap',
    'choice_tap',
];
function isValidInputMode(x) {
    return typeof x === 'string' && INPUT_MODES.includes(x);
}
/**
 * Validate an activity's input-mode configuration before persistence.
 * Returns a result object; does not throw (callers may throw ValidationError).
 */
function validateInputModeConfig(type, config) {
    const errors = [];
    const allowed = config.allowedInputModes;
    if (allowed === undefined) {
        // Missing is valid — treated as legacy single-mechanic fallback
        return { valid: true, errors: [] };
    }
    if (!Array.isArray(allowed)) {
        errors.push('allowedInputModes must be an array');
        return { valid: false, errors };
    }
    if (allowed.length === 0) {
        errors.push('At least one input mode must be enabled');
    }
    const permitted = activityTypes_1.ALLOWED_INPUT_MODES_BY_TYPE[type];
    for (const mode of allowed) {
        if (!isValidInputMode(mode)) {
            errors.push(`Invalid input mode: ${mode}`);
        }
        else if (!permitted.includes(mode)) {
            errors.push(`Input mode "${mode}" is not permitted for activity type "${type}"`);
        }
    }
    if (config.defaultInputMode !== undefined) {
        if (!isValidInputMode(config.defaultInputMode)) {
            errors.push(`Invalid default input mode: ${config.defaultInputMode}`);
        }
        else if (allowed.length > 0 && !allowed.includes(config.defaultInputMode)) {
            errors.push('defaultInputMode must be included in allowedInputModes');
        }
    }
    return { valid: errors.length === 0, errors };
}
/**
 * Get pedagogical warnings when a teacher enables modes that may conflict
 * with the activity's primary purpose. Warnings are non-blocking.
 */
function getInputModeWarnings(type, allowedModes) {
    const warnings = [];
    if (allowedModes.includes('speech')) {
        if (type === 'dictation') {
            warnings.push('Speech-to-text captures the student speaking, not the dictation audio. Use this only for oral comprehension or audit purposes.');
        }
        if (type === 'spelling' || type === 'common_exception_words') {
            warnings.push('Speech-to-text bypasses spelling practice. Enable only for accessibility cases.');
        }
    }
    return warnings;
}
